import React from 'react'
import Button from '../button/button'
import './videoCard.scss'

function VideoCard({ title, text, url, image, download, onClick }) {
  return (
    <div className={`f-video-card ${!download && "centered"}`}>
      <a href={url} target='_blank' className="f-video-card__image" onClick={(url && onClick) && onClick}>
        <img src={image} alt="video-image-reference" />
      </a>
      <div className={`${'f-video-card__text'} ${download && 'spacingbot'}`}>
        <p className="f-video-card__text__title">{title}</p>
        <p className={'f-video-card__text__content'}>{text}</p>
      </div>
      {download && (
        <div className="f-video-card__auxiliar-download">
          <div className="f-video-card__download">
            <span />
            <button
            onClick={onClick && onClick}
            >Descargar</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default VideoCard
